/**
 * Shared API utilities
 */

/**
 * Get authentication headers for API requests
 * Supports various configurations for different API needs
 *
 * @param {Object} options - Configuration options
 * @param {boolean} options.json - Include Content-Type: application/json
 * @param {boolean} options.includeGuestId - Include X-Guest-ID header for guest users
 * @returns {Object} Headers object
 */
// eslint-disable-next-line import/prefer-default-export
export const getAuthHeaders = (options = {}) => {
  const token = localStorage.getItem('token');
  const guestId = localStorage.getItem('guestId');

  return {
    ...(options.json && { 'Content-Type': 'application/json' }),
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(options.includeGuestId && guestId && { 'X-Guest-ID': guestId }),
  };
};
